module.exports = __webpack_public_path__ + "img/auto-vehicle.ec802c0c.png";